const Form029EN = {
    stepName: {
        statement: "Important Notes",
        applicationTeacherInformation: "Application Form",
        confirmation: "Confirmation",
    },
    label1: {
        header: {
            headerOne: "Notes for Completing the Application Form",
        },

        contentOption: {
            t1: "Applicants can file in duly completed application forms in person, by mail or by fax, and the Education Bureau will reply to the applicants by mail.  The address is as follows:",
            t2: "The applicants should seek the teachers’ prior consent by completing Part II of this form before submitting the applications to the Education Bureau for checking registration information.  The applicants should ensure that Part I, Part II and Part IV of this form have been duly completed.",
            t3: "The Education Bureau may request the applicants and/or the teachers to provide further information to verify the information in Part I, Part II and Part IV of this form.",
        },
        serialOption: {
            t1: "(1)",
            t2: "(2)",
            t3: "(3)",
        },
        t1Option: {
            o1: "Teacher Registration Team",
            o2: "Education Bureau",
            o3: "2/F, Trade and Industry Tower",
            o4: "3 Concorde Road",
            o5: "Kowloon",
            o6: "Tel: 3467 8282&ensp;&ensp;Fax: 2520 0065",
            // o7: "Fax: 2520 0065",
            o8: "(Office Hour: Mon to Fri: 8:30 am – 1:00 pm , 2:00 pm to 6:00 pm Saturdays, Sundays & Public holidays: Close)",
        },
        t7Option: {
            o9: "Teacher Registration Team",
            o10: "Education Bureau",
            o11: "2/F, Trade and Industry Tower",
            o12: "3 Concorde Road",
            o13: "Kowloon",
            o14: "( Tel: 3467 8282 )",
        },

        statementOne:
            "I have read, understand and agree to the above terms and conditions.",
        statementTwo:
            "I understand the applicant and the teacher need to have an “iAM Smart+” account to process the application.",
    },

    label: {
        ImportantNotesContent: {
            title: "Personal Information Collection Statement",
            p_title: "Purpose of Collection",
            p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
            p1_a: "Activities relating to the processing, authentication and counter-checking of the application for release of teacher registration information;",
            p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
            p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
            p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
            p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules) and the Codes of Aid.",

            p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

            p_title3: "Classes of Transferees",
            p3_1: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
            p3_a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
            p3_b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            p3_c: "where you have given your prescribed consent to such disclosure; and",
            p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

            p_title4: "Access to Personal Data",
            p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to Teacher Registration Team at 2/F, Trade and Industry Tower, 3 Concorde Road, Kowloon.",
            // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
        header: {
            headerOne:
                "Part I (To be completed by the person applying for releasing teacher registration information)",
            headerTwo:
                "Part II (To be completed by the teacher authorizing Education Bureau to release teacher registration information)",
            headerFour:
                "Part IV (To be completed by the person applying for releasing teacher registration information)",
            headerThree: "Part III (To be completed by Education Bureau)",
        },
        titleOption: {
            Mr: "Mr",
            Ms: "Ms",
        },
        sex: {
            male: "Male",
            female: "Female",
        },
        title: "Mr/Ms",
        englishName: "Name in English",
        chineseName: "Name in Chinese",
        chineseName2: "Name in Chinese",
        IDNumber: "HKID Card No.",
        applicantContactNo: "Applicant’s Contact No",
        nameOfApplicant: "Name of Applicant",
        teacherRegistrationNo: "Teacher Registration/Teaching Permit No",
        teachersContactNo: "Teacher’s Contact No",
        nameOfTeacher: "Name of Teacher",
        date: "Date",

        applicantName: "Name of Applicant",
        applicantAddress: "Address of Applicant",
        emailAddress: "Email Address of the Teacher",
        tips: "Please fill in the teacher’s email address below as the applicant should seek the teacher’s prior consent to complete Part II of this form before submitting the applications to the Education Bureau.",
    },
    label2: {
        l1: "I,",
        l2: "( Name in Chinese:",
        l3: "), HKID Card No.:",
        l4: ", apply for releasing the teacher registration information on matters set out in Part III related to the teacher mentioned in Part II.",
        l5: "I hereby declare that the information provided at Part I of this Form is true and complete. I have read through the content of this application form and understand the “NOTES FOR COMPLETING THE APPLICATION FORM”.",
    },
    label3: {
        l1: "I,",
        l2: " ( Name in Chinese:",
        l3: "), Teacher Registration/Teaching Permit No.:",
        l4: ", authorize the Education Bureau to release the information on the matters as set out in Part III below in relation to my teacher registration under the Education Ordinance (Cap. 279) to the person mentioned in Part I.",
        l5: "I hereby declare that the information provided at Part II of this Form is true and complete. I have read through the content of this application form and understand the “NOTES FOR COMPLETING THE APPLICATION FORM ”.",
    },
    errorMsg: {
        required: "This field is required",
        requiredTrue: "Please enter the correct field",
        IDNumber: "Please enter the correct id number",
        enName: "Please enter the correct English name",
        scName: "Please enter the correct Chinese name",
        email: "Please enter the correct email address",
        tel: {
            digit: "It needs to be 8-15 digits",
            rule: "need to match telephone number rule",
            faxRule: "need to match fax number rule",
        },
        date: {
            rule: "Please input a valid date",
            todayOrBefore: "Please select today or before",
            afterThisDate: "Please select a date after {{targetDate}}",
            age: "The applicant is at least 18 years old at the time of submission.",
        },
        tips: "Please enter the content in the correct format",
        upload: "Upload at least one file!",
        uploadMax: "Upload up to one file!",
        uploadMax5: "Upload up to five files!",
    },
    part3: {
        label1: "Dear Mr/ Ms*________ ,",
        label2: "According to our record, the teacher registration information of the above teacher is as follows:",
        option: {
            option1:
                "No teacher registration record of the above teacher has been found in EDB.",
            option2: "The above teacher is a registered teacher.",
            option3: "The above teacher is a permitted teacher.",
            option4:
                "The above teacher was a registered teacher during the period between ________ and ________ but has ceased to be a registered teacher since ________.",
            option5:
                "The above teacher was a permitted teacher during the period between ________ and ________ but has ceased to be a permitted teacher since ________.",
            option5b:
                "(A permit to teach shall be deemed to be cancelled if the permitted teacher ceases to be employed in the specified school in the permit.)",
            option6:
                "The application cannot be processed as Part II of this form has not been completed by the teacher concerned.",
        },
        label3: "Should you have any enquiries, please contact the Teacher Registration Team of EDB at 3467 8282",
    },
    submittedDialog: {
        text1: "You have successfully submitted the form. Please note that this form is not yet received by EDB. It is pending teacher’s completion of Part II.",
        text2: "The relevant email has been sent to your registered email address.",
        multiLayerSubmitMsg:
            "You are about to be redirected to fill in the application.",
    },
};
export default Form029EN;
